import { Navigate } from 'react-router';
import { useClientsPaginated } from './hooks/useClientsPaginated';

const NON_FINANCIAL_DATA_TAB = 'non-financial-data';

export function ClientRootRedirect() {
  const { items } = useClientsPaginated();
  const firstClientId = items[0]?.id;
  if (!firstClientId) return <Navigate to="/clients/all" replace />;
  return <Navigate to={`/client/${firstClientId}/${NON_FINANCIAL_DATA_TAB}`} replace />;
}
